import { useEffect, useState } from 'react';

/**
 * Returns the current time in milliseconds.
 * Re-render the component at specific interval to get a new value.
 * Set interval to 0 to disable re-rendering.
 */
export function useNow(interval: number = 30 * 1000): number {
    const [time, setTime] = useState(() => Date.now());

    useEffect(() => {
        if (interval === 0) {
            return;
        }
        const _timer = setInterval(() => {
            setTime(Date.now());
        }, interval);
        return (): void => clearInterval(_timer);
    }, [interval]);

    return time;
}
